import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef
} from '@angular/core';
import { CalendarEvent } from '../../utils/CalendarEvent';
export class DayViewAllDayEventComponent {

   event: CalendarEvent;

   customTemplate: TemplateRef<any>;

   eventTitleTemplate: TemplateRef<any>;

   eventClicked: EventEmitter<{ event: CalendarEvent }> = new EventEmitter<{
    event: CalendarEvent;
  }>();

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-day-view-all-day-event',
  template: `
    <ng-template
    #defaultTemplate
    let-event="event"
    let-eventClicked="eventClicked">
    <div
      class="cal-all-day-event"
      [style.backgroundColor]="event.color ? event.color : event.calendar.color"
      (click)="eventClicked.emit({event: event})">
      <calendar-event-action [event]="event"></calendar-event-action>
      <calendar-event-title
        [event]="event"
        view="day">
      </calendar-event-title>
    </div>
    </ng-template>
    <ng-template
    [ngTemplateOutlet]="defaultTemplate"
    [ngTemplateOutletContext]="{
      event: event,
      eventClicked: eventClicked
    }">
    </ng-template>
  `,
  styles: [`
    .cal-all-day-event{
        margin-bottom: 2px; 
        font-size: 13px;
        padding: 5px;
        cursor: pointer;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'event': [{ type: Input },],
'customTemplate': [{ type: Input },],
'eventTitleTemplate': [{ type: Input },],
'eventClicked': [{ type: Output },],
};
}

function DayViewAllDayEventComponent_tsickle_Closure_declarations() {
/** @type {?} */
DayViewAllDayEventComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DayViewAllDayEventComponent.ctorParameters;
/** @type {?} */
DayViewAllDayEventComponent.propDecorators;
/** @type {?} */
DayViewAllDayEventComponent.prototype.event;
/** @type {?} */
DayViewAllDayEventComponent.prototype.customTemplate;
/** @type {?} */
DayViewAllDayEventComponent.prototype.eventTitleTemplate;
/** @type {?} */
DayViewAllDayEventComponent.prototype.eventClicked;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
